export default __webpack_public_path__ + "graphics/people.5032611e.jpg";